export default __webpack_public_path__ + "static/small-image-bimp-2-785c19bd15b4644b00c3a64d4c97774a.png";